<h1 mat-dialog-title>Hi {{UserName}}</h1>
<div mat-dialog-content>
  <p>Are you sure, Do you want to Delete this {{BusinessName}}?
</div>
<div mat-dialog-actions style="margin-bottom: 5px;">
  <button  mat-raised-button class="dialog_button" style="background-color:black;color: white; border:1.5px solid white;border-radius: none;" (click)="onNoClick()">No Thanks</button>
  <button mat-raised-button style="background-color: black;color: white;margin-left: 15px;border:1.5px solid white;border-radius: none;" (click)="onYesClick()" cdkFocusInitial>Yes</button>
</div>